module.exports = __webpack_public_path__ + "static/img/21.e58b74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/21.png
// module id = xWtw
// module chunks = 1